import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import SocialWelfareImage from "../../../images/Certificate/Social_welfare.jpg";
import "../../../style/affiliation/socialWelfare.css";
import TranslateButton from "../../TranslateButton/TranslateButton";

const SocialWelfare = () => {
  useEffect(() => {
    document.title = `Development Concern | Social Welfare`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/affiliation/social-welfare";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="social_welfare_section">
        <div className="header_image">
          <p>Home | Affiliation</p>
          <h2>Social Welfare Certificate</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Social Welfare Registration</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Social Welfare Certificate</h1>
          <div className="content_wrapper">
            <img src={SocialWelfareImage} alt="" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SocialWelfare;
